export const ownGoodsListStyle = theme => ({
  emptyMessage: {
    // width: '100%',
    margin: theme.spacing(2, 0),
  },

  pagination: {
    marginTop: theme.spacing(2),
  },
})
